import { BellIcon } from '@heroicons/react/outline';
import { Badge } from 'antd';
import { useRouter } from 'next/router';
import useLocale from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';

import { messages } from './WhatsNew';

import { SimpleTooltip } from '@/components/ui/tooltip';

export default function WhatsNewButton(props: any) {
  const { t } = useLocale('dashboard');
  const router = useRouter();
  const [lastSeenSender, setLastSeenSender] = useLocalStorage<string>(
    'whats-new-last-seen-sender',
    '',
  );

  // useLocalStorage returns the empty initialValue on the server but the real
  // value on the client; gate `hasNew` on mount so SSR and first hydration
  // both render the badge as off, then update once storage has been read.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const latestMessageSender = messages[0]?.sender || '';
  const hasNew =
    mounted && (!lastSeenSender || latestMessageSender !== lastSeenSender);

  const scrollToWhatsNew = () => {
    setLastSeenSender(latestMessageSender);
    const isDashboard = router.pathname === '/dashboard';

    if (isDashboard) {
      const whatsNewSection =
        document.getElementById('whats-new') ||
        document.querySelector('[data-whats-new]');
      if (whatsNewSection) {
        whatsNewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      router.push('/dashboard#whats-new');
    }
  };

  return (
    <div {...props}>
      <SimpleTooltip title={t("What's New")} side='bottom'>
        <button
          onClick={scrollToWhatsNew}
          className='flex h-6 w-6 items-center justify-center rounded-lg shadow-md shadow-black/5 ring-1 ring-black/5 dark:bg-slate-700 dark:ring-inset dark:ring-white/5'
          aria-label={t("What's New")}
        >
          <Badge dot={hasNew}>
            <BellIcon className='h-4 w-4 stroke-slate-400 dark:stroke-slate-400' />
          </Badge>
        </button>
      </SimpleTooltip>
    </div>
  );
}
